var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShares(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0B966B",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 0.6,
    width: 18.8,
    height: 18.8,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.46 12.028c0 1.206 1.165 2.19 2.604 2.19 1.436 0 2.604-.984 2.604-2.19 0-1.212-1.168-2.192-2.604-2.192-1.44 0-2.605-.98-2.605-2.191 0-1.21 1.166-2.19 2.605-2.19 1.436 0 2.604.98 2.604 2.19M10.064 5.455V4.002M10.064 15.669v-1.45"
  })))));
}
export default SvgIconShares;